import React, { useState } from 'react';
import { Button, Input } from 'reactstrap';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { api } from 'services/api';
import InputMask from 'react-input-mask';
import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog';

const useStyles = makeStyles(() => ({
    tableCell: {
        flexGrow: 1,
        flexBasis: 0,
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 8px',
    },
    tableTag: {
        fontSize: '0.75rem',
        color: '#525f7f',
        fontWeight: '700',
        marginBottom: '4px',
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
    },
    loadingPrimaryPhone: {
        textAlign: 'center',
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#C2641A',
        backgroundColor: '#f8f9fe',
        borderRadius: '4px',
        marginTop: '10px',
        boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15)',
    },
}));

const TabContato = ({ order, reload, endpoint, showToast }) => {
    const classes = useStyles();
    const [isEditingPhones, setIsEditingPhones] = useState(false);
    const [telefoneParaExcluir, setTelefoneParaExcluir] = useState(null);
    const [updateInputs, setInputsUpdate] = useState({
        phoneInput: "",
        contact_phoneInput: "",
        addressInput: "",
    });
    const [loadingAddPhone, setLoadingAddPhone] = useState(false);
    const [loadingPrimaryPhone, setLoadingPrimaryPhone] = useState(false);
    const [editingPhoneId, setEditingPhoneId] = useState(null);

    const handleUpdateInput = (e) => {
        setInputsUpdate((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

    const savePhone = async (e) => {
        e.preventDefault();
        setLoadingAddPhone(true);
        try {
            if (editingPhoneId) {
                await api.patch(`/process/phones/${editingPhoneId}/`, {
                    phone: updateInputs.phoneInput,
                    contact_phone: updateInputs.contact_phoneInput,
                    address: updateInputs.addressInput,
                    status: updateInputs.statusInput,
                });
                setEditingPhoneId(null);
            } else {
                await api.post("/process/phones/", {
                    phone: updateInputs.phoneInput,
                    contact_phone: updateInputs.contact_phoneInput,
                    address: updateInputs.addressInput,
                    process_id: order.id,
                    status: "Ativo",
                });
            }
            setInputsUpdate({ phoneInput: "", contact_phoneInput: "", addressInput: "" });
            await reload(endpoint, { loader: false });
            setIsEditingPhones(false);
            showToast('success', 'Dados salvos com sucesso');
        } catch (error) {
            console.error(error);
            showToast('error', 'Falha ao salvar este telefone');
        } finally {
            setLoadingAddPhone(false);
        }
    };

    const handleEditPhone = (phoneId) => {
        const phoneToEdit = order.phones.find((phone) => phone.id === phoneId);
        setInputsUpdate({
            phoneInput: phoneToEdit.phone,
            contact_phoneInput: phoneToEdit.contact_phone,
            addressInput: phoneToEdit.address,
            statusInput: phoneToEdit.status,
        });
        setEditingPhoneId(phoneToEdit.id);
        setIsEditingPhones(true);
    };

    const handlePhoneStatusChange = async (e, phoneId) => {
        const newStatus = e.target.value;
        try {
            if ((newStatus === 'Enviado' || newStatus === 'Visualizado') && !order.is_primary) {
                await api.patch(`/process/phones/${phoneId}/`, { is_primary: true });
            }
            if (newStatus === 'Principal') {
                setLoadingPrimaryPhone(true);
                await api.patch(`/process/phones/${phoneId}/`, { is_primary: true, status: 'Principal' });
                await reload(endpoint, { loader: false });
            } else {
                await api.patch(`/process/phones/${phoneId}/`, { status: newStatus });
                await reload(endpoint, { loader: false });
            }
            showToast('success', 'Status do telefone alterado com sucesso');
        } catch (error) {
            console.error('Erro ao atualizar status do telefone:', error);
            showToast('error', 'Falha ao atualizar o status do telefone.');
        } finally {
            setLoadingPrimaryPhone(false);
        }
    };

    const deletePhone = async (phoneId) => {
        try {
            await api.delete(`/process/phones/${phoneId}/`);
            await reload(endpoint, { loader: false });
            showToast('success', 'Telefone deletado com sucesso');
        } catch (error) {
            console.error(error);
            showToast('error', 'Falha ao remover o telefone selecionado');
        }
    };

    const confirmDeletePhone = (phoneId) => {
        setTelefoneParaExcluir(phoneId);
    };

    const handleConfirmDelete = () => {
        if (telefoneParaExcluir) {
            deletePhone(telefoneParaExcluir);
            setTelefoneParaExcluir(null);
        }
    };

    const handleCancelDelete = () => {
        setTelefoneParaExcluir(null);
    };

    const getPhoneMask = (value) => {
        const digits = value.replace(/\D/g, '');
        if (digits.length > 10 || (digits.length === 10 && digits[2] === '9')) {
            return '(99) 99999-9999';
        }
        return '(99) 9999-9999';
    };

    return (
        <div>
            <ConfirmDialog
                isOpen={!!telefoneParaExcluir}
                title="Atenção"
                message="Tem certeza que deseja excluir este telefone?"
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
            />
            <div className='column-list-duelist-modal'>
                <div className={classes.tableCell}>
                    <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        <div className={classes.tableTag}>Telefones Salvos</div>
                        {!isEditingPhones && (
                            <Button
                                size="sm"
                                color="primary"
                                onClick={() => setIsEditingPhones(true)}
                                style={{ marginLeft: 'auto', backgroundColor: '#C2641A', borderColor: '#C2641A', color: '#fff', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', transition: 'background-color 0.3s ease' }}
                            >
                                Adicionar Novo
                            </Button>
                        )}
                    </div>

                    {isEditingPhones ? (
                        <form onSubmit={savePhone} style={{ width: "100%", maxWidth: "40%", margin: "0 auto", display: "flex", flexDirection: "column", padding: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius: "8px", backgroundColor: "#fff" }}>
                            <div className={classes.tableCell}>
                                <label className={classes.tableTag}>Nome</label>
                                <Input type="text" placeholder='Insira o nome do contato' id="contact_phoneInput" value={updateInputs.contact_phoneInput} onChange={handleUpdateInput} />
                            </div>
                            <div className={classes.tableCell}>
                                <label className={classes.tableTag}>Telefone</label>
                                <Input type="text" placeholder="Insira o telefone" id="phoneInput" value={updateInputs.phoneInput} onChange={handleUpdateInput} mask={getPhoneMask(updateInputs.phoneInput)} tag={InputMask} />
                            </div>
                            <div className={classes.tableCell}>
                                <label className={classes.tableTag}>Endereço</label>
                                <Input type="text" placeholder='Insira o endereço' id="addressInput" value={updateInputs.addressInput} onChange={handleUpdateInput} />
                            </div>
                            <Button type="submit" size="md" color="primary" style={{ marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} disabled={loadingAddPhone}>
                                {loadingAddPhone
                                    ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    : "Salvar"}
                            </Button>
                        </form>
                    ) : (
                        <div className='column-list-duelist-modal-telephone'>
                            {(!order.phones || order.phones.length === 0) && "Nenhum telefone salvo"}
                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                                {order.phones?.map((phone) => (
                                    <div key={`order-${order.id}-phone-${phone.id}`} style={{ flex: '0 1 48%', margin: '1%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', minHeight: '100px', backgroundColor: '#F7F7FC', padding: '8px 14px', borderRadius: '4px', boxShadow: 'inset 0px 0px 3px rgba(0, 0, 0, 0.1)' }}>
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <div><strong>Nome:</strong> {phone.contact_phone}</div>
                                            <div><strong>Telefone:</strong> {phone.phone}</div>
                                            <div><strong>Endereço:</strong> {phone.address ? phone.address : "Endereço não cadastrado"}</div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                            <Button size="sm" color="primary" onClick={() => handleEditPhone(phone.id)} style={{ backgroundColor: '#172b4d', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '4px', cursor: 'pointer', marginBottom: '5px', width: '100px', transition: 'background-color 0.3s ease' }}>
                                                Editar
                                            </Button>
                                            <Button size="sm" color="danger" onClick={() => confirmDeletePhone(phone.id)} style={{ backgroundColor: '#C2641A', color: '#fff', border: 'none', padding: '3px 10px', borderRadius: '4px', cursor: 'pointer', marginBottom: '5px', width: '100px' }}>
                                                Deletar
                                            </Button>
                                            <FormControl required style={{ margin: '10px 0', minWidth: '80px', maxWidth: '120px' }}>
                                                <Select
                                                    labelId="status-select-label"
                                                    id={`status-select-${phone.id}`}
                                                    style={{ backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '0.9rem', minWidth: '110px' }}
                                                    value={phone.status || 'Ativo'}
                                                    onChange={(e) => handlePhoneStatusChange(e, phone.id)}
                                                >
                                                    <MenuItem value="Principal">Principal</MenuItem>
                                                    <MenuItem value="Não Atende">Não Atende</MenuItem>
                                                    <MenuItem value="Ativo">Ativo</MenuItem>
                                                    <MenuItem value="Inativo">Inativo</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TabContato;
